import { toast } from "react-toastify";
import { api } from "../../Lib/constants";
import { getAuthHeader } from "../../Lib/utils";
import { ADD_WATERJUG, ADD_WATERJUG_FAILED, ADD_WATERJUG_SUCCESS, UPDATE_WATERJUG, UPDATE_WATERJUG_FAILED, UPDATE_WATERJUG_SUCCESS, WATERJUG, WATERJUG_FAILED, WATERJUG_SUCCESS } from "./actionTypes"

export const getWaterJugs = () => async (dispatch) => {
    dispatch({
        type: WATERJUG,
    })
    try {
        const response = await api(`waterjug/waterjugList`, "get", {}, getAuthHeader())
        dispatch({
            type: WATERJUG_SUCCESS,
            payload: response?.data,
        });
        return response;
    } catch (error) {
        console.log("while fetching water jug list error ====>", error);
        return dispatch({
            type: WATERJUG_FAILED,
            payload: error?.message,
        });
    }
}

export const addWaterJugs = (data) => async (dispatch) => {

    dispatch({
        type: ADD_WATERJUG
    })
    try {
        const response = await api(`waterjug/add`, "post", data, getAuthHeader())
        toast.success("Water Jug added successfully!");
        dispatch({
            type: ADD_WATERJUG_SUCCESS,
            payload: response?.data
        })
        return response;

    } catch (error) {
        console.log("while Adding water jugs error ====>>>", error);
        toast.error(error?.message);
        return dispatch({
            type: ADD_WATERJUG_FAILED,
            payload: error?.message,
        });
    }
}

export const editWaterJugs = (id, data) => async (dispatch) => {
    dispatch({
        type: UPDATE_WATERJUG
    })
    try {
        let response = await api(`waterjug/update/${id}`, 'put', data, getAuthHeader())
        toast.success("Water Jug updated successfully!");
        dispatch({
            type: UPDATE_WATERJUG_SUCCESS,
            payload: response?.data
        })
        return response
    } catch (error) {
        console.log("while updating water jug error ====>>>", error);
        toast.error(error?.message);
        return dispatch({
            type: UPDATE_WATERJUG_FAILED,
            payload: error?.message
        })
    }
}